import { Integration } from "/app/src/models";
import CurrentStorageUnitLoad from "./currentStorageUnitLoad";
import DivertTool from "./divertTool";

/**
 * Displays the appropriate component based on the display number.
 *
 * @param {Object} props - The properties object.
 * @param {Integration} props.display - The integration display information.
 * @returns {JSX.Element | null} The component corresponding to the display number or null if not found.
 */
export default function DisplayRouter({ display }: { display: Integration }) {
  switch (display.number) {
    case 1:
      return <CurrentStorageUnitLoad />;
    case 2:
      return <DivertTool />;
    default:
      return null;
  }
}
